export const COMMON_CHAT_EMOJIS: readonly string[] = [
  "😀",
  "😃",
  "😄",
  "😁",
  "😆",
  "🥹",
  "😅",
  "😂",
  "🤣",
  "🥲",
  "☺️",
  "😊",
  "😇",
  "🙂",
  "😉",
  "😌",
  "😍",
  "🥰",
  "😘",
  "😗",
  "😙",
  "😚",
  "😋",
  "😛",
  "😜",
  "🤪",
  "😝",
  "🤑",
  "🤗",
  "🤭",
  "🤔",
  "😐",
  "😑",
  "😏",
  "😒",
  "🙄",
  "😬",
  "😮‍💨",
  "😔",
  "😪",
  "😴",
  "🥵",
  "🥶",
  "🥴",
  "😵",
  "🤯",
  "🥳",
  "😎",
  "🤓",
  "😕",
  "😟",
  "🙁",
  "☹️",
  "😮",
  "😯",
  "😲",
  "😳",
  "🥺",
  "😦",
  "😧",
  "😨",
  "😰",
  "😥",
  "😢",
  "😭",
  "😱",
  "😖",
  "😣",
  "😞",
  "😓",
  "😩",
  "😫",
  "🥱",
  "😤",
  "😡",
  "😠",
  "🤬",
  "💀",
  "👻",
  "💋",
  "❤️",
  "🧡",
  "💛",
  "💚",
  "💙",
  "💜",
  "🖤",
  "💔",
  "❤️‍🔥",
  "💯",
  "🔥",
  "✨",
  "🎉",
  "🙏",
  "👍",
  "👎",
  "👏",
  "🙌",
  "🤝",
  "👌",
  "✌️",
  "🤞",
  "👋",
  "👀",
  "💪",
  "🚗",
  "🛻",
  "✅",
  "❌",
  "⚠️",
  "📞",
  "💬",
  "📍",
  "⏰",
  "💰",
];
